// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"367":"4ed56fd1","453":"1bee78b7"}[chunkId] + ".chunk.js");